import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import MsgDialog from './msg-dialog'
import * as utils from '@utils'

class ConfirmMsgDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'ConfirmMsgDialog')
        }
    }

    state = {
        type: '',
        msg: '',
        buttons: [],
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(inputs) {
        this.setState({
            type: inputs.type,
            msg: inputs.msg,
            buttons: [
                {
                    text: this.t('confirm'),
                    useLoading: true,
                    action: () => {
                        inputs.confirm(inputs.confirmParams)
                    },
                },
                {
                    text: this.t('cancel'),
                    action: () => {
                        this.closeDialog()
                    },
                    options: {
                        color: 'secondary',
                    },
                },
            ],
        })
    }

    SetConfirmBtnDisabled = (disabled) => {
        const buttons = this.state.buttons
        buttons[0].disabled = disabled
        this.setState({ buttons: buttons })
    }

    OpenDialog(inputs) {
        this.reset(inputs)
        this.dialog.OpenDialog()
    }

    closeDialog() {
        this.dialog.closeDialog()
    }

    render() {
        return <MsgDialog onRef={(ref) => (this.dialog = ref)} type={this.state.type} msg={this.state.msg} buttons={this.state.buttons} loading={this.props?.loading||false} />
    }
}

const styles = (_theme) => {
    return {}
}

ConfirmMsgDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    loading: PropTypes.bool
}

export default hoc(styles)(ConfirmMsgDialog)
